/**
 * Updates the product title variant options line (e.g. "Blue - 128GB - Fair")
 * when the variant changes via variant:update event.
 */
import { ThemeEvents } from '@theme/events';

function buildVariantOptionsLine(variant) {
  if (!variant) return '';
  const parts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
  return parts.join(' - ');
}

function init() {
  const lineEl = document.querySelector('[data-variant-options-line]');
  if (!lineEl) return;

  const section = lineEl.closest('.shopify-section');
  if (!section) return;

  const lineEls = section.querySelectorAll('[data-variant-options-line]');

  section.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const productId = event.detail?.data?.productId;
    if (!productId) return;
    const formInSection = section.querySelector(`product-form-component[data-product-id="${productId}"]`);
    if (!formInSection) return;
    const line = buildVariantOptionsLine(event.detail.resource);
    lineEls.forEach((el) => {
      const suffix = el.getAttribute('data-sim-battery-suffix');
      const text = suffix ? (line ? `${line} - ${suffix}` : suffix) : (line || '');
      el.textContent = text;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
